import styled from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { Field } from 'formik';

import { flex, rem } from '../../../core';

const modifiers = {
  radial: ({ theme }) => ({
    styles: `
      .checkbox__input {
        &:checked ~ .checkbox__IconContainer {
          background-color: white;
          ::before {
            opacity: 1;
          }
        }
      }
      .checkbox__IconContainer {
        background-color: white;
        ${flex('row', 'center', 'center')};
        border-radius: ${rem(25)};
        ::before {
          content: '';
          background-color: ${theme.primary.main};
          height: ${rem(6)};
          width: ${rem(6)};
          border-radius: ${rem(25)};
          display: block;
          opacity: 0;
        }
        svg {
          display: none;
        }
      }
    `,
  }),
  disabled: ({ theme }) => ({
    styles: `
      color: ${theme.grey};
      pointer-events: none;
      .checkbox__IconContainer {
        border-color: ${theme.grey};
      }
    `,
  }),
  deactivated: ({ theme }) => ({
    styles: `
      color: ${theme.grey};
      .checkbox__IconContainer {
        border-color: ${theme.grey};
      }
    `,
  }),
};

export const Check = styled(Field).attrs({
  className: 'checkbox__input',
})``;

export const CheckStyled = styled.label.attrs({
  className: 'component__Checkbox',
})`
  ${flex('row', 'flex-start', 'center')};
  font-size: ${rem(15)};
  cursor: pointer;

  .checkbox__input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ .checkbox__IconContainer {
      background-color: ${(props) => props.theme.primary.main};
      border-color: ${(props) => props.theme.primary.main};

      svg {
        fill: white;
        opacity: 1;
      }
    }

  }

  .checkbox__IconContainer {
    font-size: ${rem(9)};
    color: ${(props) => props.theme.primary.main};
    width: 1rem;
    height: 1rem;
    border: 1.5px solid ${(props) => props.theme.primary.main};
    border-radius: 2px;
    margin-right: ${rem(8)};
    ${flex('row', 'center', 'center')};
    svg {
      width: 0.7rem;
      height: 0.7rem;
      opacity: 0;
    }
  }

  ${applyStyleModifiers(modifiers)};
`;

export const IconContainer = styled.span.attrs({
  className: 'checkbox__IconContainer',
})`
`;
